export default {"src":"/_next/static/media/mb-sm.7aa9f867.svg","height":40,"width":66,"blurWidth":0,"blurHeight":0};